export default __webpack_public_path__ + "static/media/Upendra.bab82c15.jpg";